<template>
  <div class="EditDiary">
    <div class="block">
      <div class="close">
        <img @click="closeDiary()" src="@/assets/purpleClose.png" />
      </div>
      <div class="title">
        <div>编辑器</div>
        <div>效果图</div>
      </div>
      <markdown-pro v-model="content" :bordered="false" />
      <div class="btn">
        <img @click="saveDiary(true)" src="@/assets/save.png" />
      </div>
    </div>

  </div>
</template>

<script>
import { MarkdownPro, MarkdownPreview } from 'vue-meditor'
import { PUT, GET } from '@/utils/request'

export default {
  name: "EditDiary",
  components: {
    MarkdownPro,
    MarkdownPreview
  },
  props: {
    pk: Number,
  },
  data () {
    return {
      content: '',
    }
  },
  mounted () {
    // this.pk = this.$route.params.pk;
    let storagContent = localStorage.getItem('diary' + this.pk)
    if (storagContent && storagContent != "null") {
      this.content = storagContent
      this.saveDiary(false)
    } else {
      this.getDiary()
    }
    let _this = this
    window.onbeforeunload = function (event) {
      localStorage.setItem('diary' + _this.pk, _this.content)
    };
    if (window.history && window.history.pushState) {
      //监听浏览器前进后退事件
      window.onpopstate = function () {
        localStorage.setItem('diary' + _this.pk, _this.content)
      }
    }
  },
  methods: {
    getDiary () {
      GET(`/server/community/content_diary/${this.pk}/`).then(res => {
        this.content = res.content
      })
    },
    saveDiary (type) {
      PUT('/server/community/update_diary/' + this.pk + "/", {
        content: this.content
      })
        .then(res => {
          if (type) {
            this.$emit("getdate")
            this.$message.success('保存成功')
          }
        })
    },
    closeDiary () {
      localStorage.setItem('diary' + this.pk, this.content)
      this.$emit("update:showEdit", false)
    }
  }
}
</script>

<style  lang="less" scoped>
/deep/.markdown .markdown-content .markdown-preview {
  background: #f1f1fe;
}
/deep/.markdown {
  height: 86vh !important;
  .cm-s-default * {
    color: #111111;
  }
  .cm-s-default .CodeMirror-cursor {
    border-left: solid thin #333;
  }
}
/deep/.cm-s-default .CodeMirror-gutter {
  background: #e6ebf9;
}
/deep/.cm-s-default.CodeMirror {
  background-color: #fff !important;
}

.EditDiary {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  z-index: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  .block {
    width: 70vw;
    margin: auto;
    padding: 0 10px 10px 10px;
    background: #644ed9;
    position: relative;
    .title {
      height: 40px;
      display: flex;
      align-items: center;
      div {
        text-align: center;
        color: #ffffff;
        font-size: 18px;
        width: 50%;
      }
    }
    .close {
      position: absolute;
      right: -80px;
      top: 0;
      cursor: pointer;
      img {
        width: 40px;
      }
    }
  }
}
.btn {
  position: absolute;
  right: -120px;
  bottom: 0;
  cursor: pointer;
  img {
    width: 80px;
  }
}
</style>